<template>
  <el-select
    :value="value"
    size="small"
    @change="handleChange"
    placeholder="搜索并选择"
    style="width: 100%"
    filterable
    :clearable="clearable"
  >
    <el-option v-if="clearable" :key="0" label="不限" :value="0"></el-option>
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { productTemplateList } from '@/service/getData'

export default {
  props: {
    value: '',
    clearable: {
      type: Boolean,
      default: false,
    },
    category: {
      type: Number,
      default: 0,
    },
    assetType: {
      type: Number,
      default: 0,
    },
    //是否包含无编号分类
    all: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lists: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      let data = {
        category: this.category,
        asset_type: this.assetType,
        size: 200,
      }
      if (this.all) {
        data.code_type = 0
      }
      let res = await productTemplateList(data)
      if (res.status == 0) {
        this.lists = res.data.list
      }
    },
    handleChange(e) {
      this.$emit('input', e)
      this.$emit(
        'codeType',
        e ? this.lists.find((i) => i.id == e).code_type : 1,
      )
    },
  },
}
</script>
<style>
.select-err .el-input__inner {
  border-color: #f56c6c;
}
</style>